import { addDays, endOfDay, startOfDay, subDays } from 'date-fns';
import { EmptyFilter, OperatorFilter, RangeFilter, TermFilter } from '@dofleini/query-builder';
import { DELIVERY_MAX_TIME_ENUM } from '../constants/order.enum';
import { ORDER_STATUS_TYPE_ENUM } from 'modules/sales/settings/order-status/constants';

type DeliveryTimeTypeProps = { field: string; value: DELIVERY_MAX_TIME_ENUM | DELIVERY_MAX_TIME_ENUM[] };

export const parseRangeFilter = ({ field, value }: DeliveryTimeTypeProps) => {
  switch (value) {
    case DELIVERY_MAX_TIME_ENUM.TIME:
      return new RangeFilter({
        field,
        isDate: true,
        from: startOfDay(new Date()),
        to: addDays(endOfDay(new Date()), 4),
      });
    case DELIVERY_MAX_TIME_ENUM.RISK:
      return new RangeFilter({
        field,
        isDate: true,
        from: startOfDay(new Date()),
        to: addDays(endOfDay(new Date()), 1),
      });
    case DELIVERY_MAX_TIME_ENUM.LATE:
      return new RangeFilter({
        field,
        isDate: true,
        to: subDays(endOfDay(new Date()), 2),
      });

    case DELIVERY_MAX_TIME_ENUM.SEVERE:
      return new RangeFilter({
        field,
        isDate: true,
        to: subDays(endOfDay(new Date()), 3),
      });
    case DELIVERY_MAX_TIME_ENUM.CRITICS:
      return new RangeFilter({
        field,
        isDate: true,
        to: subDays(startOfDay(new Date()), 4),
      });

    default:
      return new EmptyFilter();
  }
};

export const deliveryMaxTimeFilterTransform = ({ field, value }: DeliveryTimeTypeProps) => {
  const makeFilter = (v: DELIVERY_MAX_TIME_ENUM) => {
    const dateFilter = parseRangeFilter({ field, value: v });

    const excludeStatusFilter = new TermFilter({
      field: 'status.type',
      value: { $ne: ORDER_STATUS_TYPE_ENUM.COMPLETED },
    });

    return new OperatorFilter({
      type: 'AND',
      filters: [dateFilter, excludeStatusFilter],
    });
  };

  if (Array.isArray(value)) {
    const filters = value.map(makeFilter);
    return new OperatorFilter({
      type: 'OR',
      filters,
    });
  }

  return makeFilter(value);
};

export const d = '';
